import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { getOffsetFromTimezone } from '@features/General/dayjs/hanlers'

dayjs.extend(utc)
dayjs.extend(timezone)
export const prepareDownloadAndSendQuery = (companyId, pureFilters) => {
    const query: any = {}
    if (companyId) {
        query.companies = [companyId]
    }
    Object.keys(pureFilters).forEach(key => {
        const value = pureFilters[key]
        if (value.length) {
            if (key === 'meetingDate') {
                if (value[0]) {
                    const date = dayjs(value[0], 'YYYY-MM-DD hh:mm AZ')
                    query[key] = { $gte: date.utc().set('hour', 0).set('minute', 0).set('second', 0).format() }
                }

                if (value[1]) {
                    const date = dayjs(value[1], 'YYYY-MM-DD hh:mm AZ')
                    query[key].$lte = date.utc().set('hour', 0).set('minute', 0).set('second', 0).format()
                }
                // value.utc().set({ hour: 0, minute: 0, second: 0 }).format()
            } else if (key === 'timeShift') {
                const offset = getOffsetFromTimezone(value)
                query[key] = offset
            } else {
                query[key] = value
            }
        }
    })
    return query
}
